import firebase from '../config/firebase.config';

const db = firebase.firestore();

// ── Company level ─────────────────────────────────────────────────────────────

export async function fetchProductivityApps(companyId) {
  const snap = await db.collection('companyDatabase').doc(companyId).get();
  if (!snap.exists) return { focusApps: [], distractionApps: [] };
  const data = snap.data();
  return {
    focusApps: Array.isArray(data.focusApps) ? data.focusApps : [],
    distractionApps: Array.isArray(data.distractionApps)
      ? data.distractionApps
      : [],
  };
}

export async function saveProductivityApps(
  companyId,
  { focusApps, distractionApps }
) {
  await db
    .collection('companyDatabase')
    .doc(companyId)
    .set({ focusApps, distractionApps }, { merge: true });
}

// ── Team level ────────────────────────────────────────────────────────────────

export async function fetchTeamProductivityApps(teamId) {
  const snap = await db.collection('teamDatabase').doc(teamId).get();
  if (!snap.exists)
    return { hasOverride: false, focusApps: [], distractionApps: [] };
  const data = snap.data();
  const hasOverride = 'focusApps' in data;
  return {
    hasOverride,
    focusApps: Array.isArray(data.focusApps) ? data.focusApps : [],
    distractionApps: Array.isArray(data.distractionApps)
      ? data.distractionApps
      : [],
  };
}

export async function saveTeamProductivityApps(
  teamId,
  { focusApps, distractionApps }
) {
  await db
    .collection('teamDatabase')
    .doc(teamId)
    .set({ focusApps, distractionApps }, { merge: true });
}

export async function resetTeamProductivityApps(teamId) {
  await db.collection('teamDatabase').doc(teamId).update({
    focusApps: firebase.firestore.FieldValue.delete(),
    distractionApps: firebase.firestore.FieldValue.delete(),
  });
}
